import React from "react";
import styled from "styled-components";
import { transitionMixin, flexCenter } from "../mixins";

const Button = styled.button`
    padding: 10px 20px;
    ${flexCenter};
    color: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.black};
    font-family: ${({ theme }) => theme.ff.Montserrat};
    font-weight: ${({ theme }) => theme.fw.bold};
    font-size: ${({ theme }) => theme.fz.XXS};
    text-decoration: none;
    ${transitionMixin()};

    &:hover {
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
    }
`;

export default Button;
